import {BLOCK_HOUR} from "@/types/constants";
import { CommonResponse } from "./response";
const { calculateBuildingUpgradeTime: calculateContractBuildingUpgradeTime } = require("./upgradeCosts");
const { calculateTroopTrainingTime: calculateContractTroopTrainingTime } = require("./troopCosts");

export function msToTime(s: number) {
	const ms = s % 1000;
	s = (s - ms) / 1000;
	const secs = s % 60;
	s = (s - secs) / 60;
	const mins = s % 60;
	const hrs = (s - mins) / 60;

	const days = Math.floor(hrs / 24);
	const remainHrs = hrs % 24;

	const parts: string[] = [];
	if (days > 0) parts.push(`${days}d`);
	if (remainHrs > 0 || days > 0) parts.push(`${remainHrs}h`);
	if (mins > 0 || parts.length > 0) parts.push(`${mins}m`);
	if (parts.length === 0) parts.push(`${secs}s`);

	return parts.join(' ');
}

/**
 * Returns the time taken to upgrade a building to the next level
 * @param hq_level
 * @param building_level
 * @param base_time
 */
export function calculateBuildingUpgradeTime(hq_level: number, building_level: number, base_time: number) {
	return calculateContractBuildingUpgradeTime(hq_level, building_level, base_time);
}

/**
 * Returns total troop training blocks for a purchase.
 * Mirrors contract logic in `Village::train_troops`.
 */
export function calculateTroopTrainingTime(base_training_time: number, barracks_level: number, amount: number, game_speed = 1) {
	return calculateContractTroopTrainingTime(base_training_time, barracks_level, amount, game_speed);
}


/**
 * Returns the hourly resource production for a building
 * @param building_level
 * @param resource_factor
 */
export function calculateHourlyResourceProductionRate(building_level: number, resource_factor: number) {
	const growth_rate = 1.163;
	const production_rate = 30.0 * Math.pow(growth_rate, building_level)
	return production_rate * resource_factor;
}

/**
 * Returns the per-block resource production for a building
 * @param building_level
 * @param resource_factor
 */
export function calculateResourcesPerBlock(building_level: number, resource_factor: number) {
	return calculateHourlyResourceProductionRate(building_level, resource_factor) / BLOCK_HOUR
}

/**
 * Convert slot to unix time
 * @param slot
 * @param slotsPerSecond
 */
export function slotToDate(slot: number, slotsPerSecond = 2.3736885) {
	const solanaStartTime = 1593561600; // Mainnet-beta start timestamp (2020-07-01T00:00:00Z)
	const secondsSinceStart = slot / slotsPerSecond;
	const timestamp = solanaStartTime + secondsSinceStart;
	return new Date(timestamp * 1000); // Convert to milliseconds for JavaScript Date
}

export const fmtK = new Intl.NumberFormat('en', { notation: 'compact' as const });

export async function tryCatch<T>(
  fn: () => Promise<CommonResponse<T>>,
): Promise<CommonResponse<T>> {
  try {
    const res = await fn();
    return { ...res };
  } catch (error) {
    return { error: error as Error, ok: false };
  }
}
